import { useEffect, useRef, useState } from "react";

import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "styled-components";

const Container = styled.div`
  position: relative;
  display: inline-block;
`;

const Button = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 35px;
  padding: 7px 12px;
  background: var(--neutral-1, #fff);
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
  text-align: left;
  border-radius: 2px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  cursor: pointer;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.56px;
`;

const ArrowIcon = styled.span`
  margin-left: 8px;
`;

const Content = styled.div`
  display: ${(props) => (props.$isOpen ? "block" : "none")};
  position: absolute;
  z-index: 1;
  margin-top: 2px;
  background-color: #ffffff;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  text-align: left;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.56px;
`;

const Item = styled.div`
  color: black;
  padding: 8px 0 8px 12px;
  cursor: pointer;

  &:hover {
    background-color: #ddd;
  }
`;

/**
 * 여러 옵션 중 하나를 고르는 공용 드롭다운(Select).
 * 기존 3종 Dropdown.js를 대체한다. 바깥 클릭 시 자동으로 닫힌다.
 *
 * @param options  string[]
 * @param value    현재 선택된 값
 * @param onChange (option) => void
 * @param width    CSS width (기본 120px)
 */
export function SelectDropdown({ options, value, onChange, width = "120px" }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const handlePick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <Container ref={containerRef}>
      <Button
        type="button"
        style={{ width }}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {value}
        <ArrowIcon>
          <FontAwesomeIcon icon={faChevronDown} />
        </ArrowIcon>
      </Button>
      <Content $isOpen={isOpen} style={{ width }}>
        {options.map((option) => (
          <Item key={option} onClick={() => handlePick(option)}>
            {option}
          </Item>
        ))}
      </Content>
    </Container>
  );
}

export default SelectDropdown;
